import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-tv-option-details',
  templateUrl: './skeleton-tv-option-details.component.html',
})
export class SkeletonTvOptionDetailsComponent implements OnDestroy {
  constructor() {
    // adapt the page header to negative colors of TV option details page
    const el = document.querySelector('.rs-header2020');
    if (el) {
      el.className = 'rs-header2020 rs-header-neg';
    }
    const elTlc = document.querySelector('.rs-header-tlc');
    if (elTlc) {
      elTlc.setAttribute('style', 'display: none');
    }
  }

  ngOnDestroy() {
    // put back normal header
    const el = document.querySelector('.rs-header2020');
    if (el) {
      el.className = 'rs-header2020';
    }
    const elTlc = document.querySelector('.rs-header-tlc');
    if (elTlc) {
      elTlc.removeAttribute('style');
    }
  }
}
